import type { RequestConfig } from '@customTypes/index';
import type { WorkRequestItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type UpdateWorkRequestParams = RequestConfig<
  Pick<WorkRequestItemDto, 'workRequestId'> &
    Partial<Omit<WorkRequestItemDto, 'workRequestId'>>
>;

export const updateWorkRequest = async ({
  params,
  config
}: UpdateWorkRequestParams) =>
  api.put<WorkRequestItemDto>(`/api/work/requests`, params, config);
